/**
 * @generated SignedSource<<6ac581b841c98c1f92f76a044892dd3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteExpectedSourceInputObject = {
  expectedSourceId: string;
};
export type statementsPage_DeleteExpectedSourceMutation$variables = {
  input: DeleteExpectedSourceInputObject;
};
export type statementsPage_DeleteExpectedSourceMutation$data = {
  readonly deleteExpectedSource: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly expectedSource: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type statementsPage_DeleteExpectedSourceMutation = {
  response: statementsPage_DeleteExpectedSourceMutation$data;
  variables: statementsPage_DeleteExpectedSourceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpectedSource",
  "kind": "LinkedField",
  "name": "expectedSource",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "statementsPage_DeleteExpectedSourceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteExpectedSourceMutationPayload",
        "kind": "LinkedField",
        "name": "deleteExpectedSource",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "statementsPage_DeleteExpectedSourceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteExpectedSourceMutationPayload",
        "kind": "LinkedField",
        "name": "deleteExpectedSource",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7ac3a15dee223ac5aa4ec14235ec95b2",
    "id": null,
    "metadata": {},
    "name": "statementsPage_DeleteExpectedSourceMutation",
    "operationKind": "mutation",
    "text": "mutation statementsPage_DeleteExpectedSourceMutation(\n  $input: DeleteExpectedSourceInputObject!\n) {\n  deleteExpectedSource(input: $input) {\n    expectedSource {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7503ac1d6ec638a13cb1c8fea00d53b4";

export default node;
